import { Tab, Tooltip } from '@mui/material';
import { ALL_APP_IDS, ALL_APPS } from 'constants/appConstants';
import { gridSpacing } from 'constants/themeConstants';
import { useAppAccessContext } from 'contexts/AppAccessContext';
import { SyntheticEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SegmentTabs from 'ui-component/Segment/SegmentTabs';
import { getDisabledPermissionCopy } from 'utils/permissions';

const ViewTabs = ({ appId }: { appId: ALL_APP_IDS }) => {
  const { isPermissionDisabled, getDisabledReason } = useAppAccessContext();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const app = ALL_APPS[appId];

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    const screenTop = window.scrollY;
    navigate(newValue);
    window.scrollTo({
      top: screenTop,
      behavior: 'smooth',
    });
  };

  return (
    <SegmentTabs
      value={pathname}
      indicatorColor="primary"
      textColor="primary"
      onChange={handleChange}
      aria-label="Tabs"
      variant="scrollable"
      sx={{ mb: gridSpacing }}
    >
      {Object.values(app.views || {}).map((view) => {
        const isDisabled = isPermissionDisabled({
          app: appId,
          view: view.id,
        });
        const disabledReason = getDisabledPermissionCopy(
          getDisabledReason({
            app: appId,
            view: view.id,
          })
        ).message;
        return (
          <Tab
            key={view.id}
            value={view.path}
            label={
              <Tooltip title={isDisabled && disabledReason}>
                <span>{view.name}</span>
              </Tooltip>
            }
            icon={<view.icon />}
            iconPosition="start"
            disabled={isDisabled}
          />
        );
      })}
    </SegmentTabs>
  );
};

export default ViewTabs;
